/* SK Journal — "The Kitchen Journal" index.
   Client-side filter (type + goal + search), Load-more, sticky filter bar,
   scroll-reveal. Reads everything off data-* attributes on the cards. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- scroll reveal ---- */
  var fx = document.querySelectorAll('.skj-fx');
  if (fx.length) {
    if (reduce || !('IntersectionObserver' in window)) {
      fx.forEach(function (el) { el.classList.add('is-vis'); });
    } else {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-vis'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.1 });
      fx.forEach(function (el) { io.observe(el); });
    }
  }

  var grid = document.querySelector('.skj-grid');
  if (!grid) return;

  var posts = Array.prototype.slice.call(grid.querySelectorAll('.skj-post'));
  var gbreak = grid.querySelector('.skj-gbreak');
  var empty = document.querySelector('.skj-empty');
  var loadBtn = document.querySelector('.skj-loadmore');
  var typePills = Array.prototype.slice.call(document.querySelectorAll('.skj-fpill'));
  var goalPills = Array.prototype.slice.call(document.querySelectorAll('.skj-gpill'));
  var search = document.querySelector('.skj-search input');

  var INITIAL = 9, STEP = 6;
  var state = { type: 'all', goal: null, q: '' };
  var shown = INITIAL;

  function postData(el) {
    return {
      el: el,
      cat: el.getAttribute('data-cat') || '',
      goals: (el.getAttribute('data-goals') || '').toLowerCase().split(/\s+/).filter(Boolean),
      title: (el.getAttribute('data-title') || el.textContent || '').toLowerCase()
    };
  }
  var data = posts.map(postData);

  function matches(p) {
    if (state.type !== 'all' && p.cat !== state.type) return false;
    if (state.goal && p.goals.indexOf(state.goal) === -1) return false;
    if (state.q && p.title.indexOf(state.q) === -1) return false;
    return true;
  }

  function isDefault() { return state.type === 'all' && !state.goal && !state.q; }

  function render() {
    var count = 0, matched = 0;
    data.forEach(function (p) {
      var ok = matches(p);
      if (!ok) { p.el.classList.add('is-hide'); return; }
      matched++;
      if (count < shown) { p.el.classList.remove('is-hide'); count++; }
      else { p.el.classList.add('is-hide'); }
    });
    if (gbreak) gbreak.classList.toggle('is-hide', !isDefault());
    if (empty) empty.classList.toggle('is-show', posts.length > 0 && matched === 0);
    if (loadBtn) loadBtn.hidden = (matched <= shown) || matched === 0;
  }

  typePills.forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.type = btn.getAttribute('data-type') || 'all';
      typePills.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      shown = INITIAL; render();
    });
  });

  goalPills.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var g = (btn.getAttribute('data-goal') || '').toLowerCase();
      if (state.goal === g) { state.goal = null; btn.setAttribute('aria-pressed', 'false'); }
      else {
        state.goal = g;
        goalPills.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      }
      shown = INITIAL; render();
    });
  });

  if (search) {
    var t;
    search.addEventListener('input', function () {
      clearTimeout(t);
      t = setTimeout(function () { state.q = search.value.trim().toLowerCase(); shown = INITIAL; render(); }, 120);
    });
  }

  if (loadBtn) {
    loadBtn.addEventListener('click', function () { shown += STEP; render(); });
  }

  /* ---- sticky filter bar shadow ---- */
  var bar = document.querySelector('.skj-filterbar');
  if (bar) {
    var onScroll = function () { bar.classList.toggle('is-stuck', bar.getBoundingClientRect().top <= 0.5); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  render();
})();
